module.exports = __webpack_public_path__ + "static/media/coins_modal2.7943131e.png";